/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FindAndReplaceIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Find And Replace',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.63 32.628-6.275-8.385a12.011 12.011 0 1 0-20.63-6.9A6.561 6.561 0 0 0 11 18.623a10.005 10.005 0 1 1 9.087 7.313c-.031.019-.058.046-.089.064a12.327 12.327 0 0 1-3.5 1.265 11.988 11.988 0 0 0 9.393-.478l6.275 8.385a2.155 2.155 0 0 0 3.466-2.544Z"
    />
    <path
      d="M23.467 15.737a11.152 11.152 0 0 1-5.213 6.974c-5.068 2.8-11.526.878-14.8-4.259l2.415-1.336A8.337 8.337 0 0 0 16.752 20a7.605 7.605 0 0 0 3.92-5.1l-3.763-1.125 6.777-3.748 3.828 6.92ZM8.556 5.071a6.5 6.5 0 0 1 4.416-1.151 13.873 13.873 0 0 1 3.4-1.435 8.915 8.915 0 0 0-9.309.5A8.746 8.746 0 0 0 3.5 9.164L0 8.575l3.8 5.332 5.322-3.795L5.9 9.569a6.213 6.213 0 0 1 2.656-4.498Z"
    />
  </svg>`;
};
